import tmhRequest from '@/config/tmhRequest'

export default {
  searchProduct: function (data) {
    return tmhRequest({
      url: '/project/product/searchproduct',
      method: 'post',
      params: data,
    })
  },
  searchListProduct: function (data) {
    return tmhRequest({
      url: '/project/product/searchlistproduct',
      method: 'post',
      params: data,
    })
  },
  searchNoPlusProduct: function (data) {
    return tmhRequest({
      url: '/project/product/searchnoplusproduct',
      method: 'post',
      params: data,
    })
  },
  
  searchProductCount: function (data) {
    return tmhRequest({
      url: '/project/product/searchproductcount',
      method: 'post',
      params: data,
    })
  },
  searchProductByPage: function (data) {
    return tmhRequest({
      url: '/project/product/searchproductbypage',
      method: 'post',
      params: data,
    })
  },
  addProduct: function (data) {
    return tmhRequest({
      url: '/project/product/addproduct',
      method: 'post',
      data: data,
    })
  },
  addProductGroup: function (data) {
    return tmhRequest({
      url: '/project/product/addproductgroup',
      method: 'post',
      data: data,
    })
  },
  
  editProduct: function (data) {
    return tmhRequest({
      url: '/project/product/editproduct',
      method: 'post',
      data: data,
    })
  },
}


// WEBPACK FOOTER //
// ./src/api/tmh/item/product.js